export default __webpack_public_path__ + "static/media/no2_scale.d57b31a1.png";